export default "__VITE_ASSET__uvXtAH9C__"